import moment from "moment";
import { today } from "../../common-data/DropdowData";

export const validateWalkinsForm = (formValues, modValues) => {
  let errors = {};

  if (!formValues.custName) {
    errors.custName = "required!";
  }

  if (!formValues.custMobile) {
    errors.custMobile = "required!";
  }

  if (formValues.isAssignDifferentReceptionist) {
    if (!formValues.selectedReceptionist) {
      errors.selectedReceptionist = "required!";
    }

    if (!formValues.selectedGym) {
      errors.selectedGym = "required!";
    }
  }

  if (!formValues.selectedGender) {
    errors.selectedGender = "required!";
  }

  if (!formValues.memberDOB) {
    errors.memberDOB = "Date of birth is required!";
  } else {
    const enteredDOB2 = moment
      .tz(formValues.memberDOB, "Asia/Kolkata")
      .startOf("day");
    if (!enteredDOB2.isBefore(today)) {
      errors.memberDOB = "DOB cannot be today or in the future!";
    } else {
      const age = today.diff(enteredDOB2, "years");
      if (age < 10) {
        errors.memberDOB = "Member must be at least 10 years old!";
      }
    }
  }

  if (formValues.custEmail && !modValues.isEmailVerified) {
    errors.custEmail = "email must be verified before submitting!";
  }

  if (formValues.custMobile && !modValues.isMobileVerified) {
    errors.custMobile = "Mobile number must be verified before submitting!";
  }

  return errors;
};
